import { UserResponse } from "./user.model";

export class CompanyActivityNameResponse {
	code: any;
	id: number;
	name: string;
}

export class NewCompanyRequest {
	userId: number;
	photos: string[] = [];
	geolocation: string;
	companyData: CompanyRequest;
	date: number;
	description: string;
	companyPass: number;
	pass: string;
}

export class NewDateDteRequest {
	idCompany: number;
	dateDte: Date;
}

export class CompanyRequest {
	activities: number[] = [];
	address: string;
	contacts: CompanyContactRequest[] = [];
	facebook: string;
	logo: string;
	mail: string;
	name: string;
	nit: string;
	page: string;
	phones: CompanyPhoneRequest[] = [];
	representative: string;
	representativeMail: string;
	schedules: CompanyScheduleRequest[] = [];
	town: number;
	twitter: string;
	administrative?: boolean;
}

export class CompanyContactRequest {
	mail: string;
	name: string;
	phone: number;
}

export class CompanyPhoneRequest {
	area: number;
	extension: number;
	phone: number;
}

export class CompanyScheduleRequest {
	closing: string;
	day: number;
	opening: string;
}

export class CompanyPackageResponse {
	creator: any;
	description: string;
	finalConsumer: boolean;
	id: number;
	name: string;
	packageTiers: PackageTierResponse[] = [];
}

export class PackageTierResponse {
	description: any;
	id: number;
	name: string;
	packageGroupId: number;
	packages: PackageItemResponse[] = [];
}

export class PackageItemResponse {
	description: string;
	id: number;
	name: string;
	packagePeriods: PackagePeriodResponse[] = [];
	packageServices: PackageServiceResponse[] = [];
	packageTier: number;
}

export class PackagePeriodResponse {
	discount: number;
	discountPrice: number;
	id: number;
	isPercentage: boolean;
	onlyCredirCard: boolean;
	packageId: number;
	periodData: PeriodDataResponse[] = []
}

export class PeriodDataResponse {
	id: number;
	name: string;
}

export class PackageServiceResponse {
	amount: number;
	id: number;
	packageId: number;
	serviceData: ServiceDataResponse;
	serviceId: number;
	tierData: TierDataResponse;
	tierId: number;
	unitData: any;
	unitId: any;
	unitName: any;
	unitPrice: any;
}

export class TierDataResponse {
	associateCost: number;
	associateCostUSD: number;
	id: number;
	name: string;
	selectable: boolean;
}

export class ServiceDataResponse {
	canBeGiven: boolean;
	canGive: boolean;
	description: string;
	digital: boolean;
	displayName: string;
	give: string;
	icon: string;
	id: number;
	name: string;
	parentId: number;
	parentName: string;
	route: string;
}

export class AssociateCompanyRequest {
	companyActivities: number[] = [];
	companyName: string;
	companyNit: string;
	companyTaxRegime: number = 1;
	contactEmail: string;
	contactName: string;
	contactPhone: number;
	userId: number;
}

export class AssociateCompanyResponse {
	alphanumericId: string;
	commission: any;
	id: number;
	name: string;
	nit: string;
	total: any;
}

export class AccountantRequest {
	mail: string;
	name: string;
	nit: string;
	phone: string;
	taxRegime: number = 1;
}

export class CompanyConfigResponse {
	displayName: string;
	id: number;
	module: number;
	name: string;
	type: string;
	value: any;
	wsURL: any;
	management: number;
	management_label: string;
	description: string;
}

export class CompanyRoleResponse {
	alphanumericId: string;
	companyId: number;
	companyLogo: string;
	companyNIT: string;
	companyName: string;
	edit: boolean;
	roles: any[];
	services: any;
	solvent: boolean;
	unReadTickets: any;
	administrative?: boolean;
}

export class CompanyResponse {
	accountant: any;
	acronym: any;
	active: boolean;
	address: string;
	alphanumericId: string;
	associate: any;
	associateParent: any;
	associateUser: any;
	balance: number;
	correlative: number;
	creationDate: number;
	creator: number;
	facebook: string;
	fcolor: string;
	id: number;
	logo: string;
	mail: string;
	managedByCompany: number;
	managedByUser: any;
	name: string;
	nfact: number;
	nit: string;
	nomenclatureAccepted: boolean;
	owner: UserResponse;
	page: string;
	prospect: boolean;
	representative: string;
	representativeDoc: any;
	representativeMail: string;
	scolor: string;
	seller: any;
	tcolor: string
	test: boolean;
	town: number;
	transferredTo: any;
	passwordSat: string;
	twitter: string;
	passwordRequest!: PasswordSATRequest;
	dateDte: Date;
	deletingPasswordSat: boolean = false;
}

export class CompanyDataResponse {
	id: number;
	name: string;
	logo: any;
}

export class PasswordSATRequest {
	newPassword: string;
	confirmPassword: string;
	loading: boolean;
	edit: boolean;
}

export class EventGPSResponse {
	application: CompanyApplicationResponse;
	assisted: boolean;
	date: number;
	description: string;
	eventId: number;
	report: string;
	showed: boolean;
}

export class CompanyApplicationResponse {
	applicationId: number;
	geolocation: string;
	newCompany: CompanyResponse;
	parentCompany: CompanyResponse;
	pending: boolean;
	userId: UserResponse;
	coordinates!: CoordinatesModel;
}

export class CoordinatesModel {
	lat: number;
	lng: number;

	constructor(coordinates: string = null) {
		if (coordinates != null) {
			this.lat = parseFloat(coordinates.split(',')[0]);
			this.lng = parseFloat(coordinates.split(",")[1]);
		}
	}
}

export class PaginationApplicationsResponse {
	total: number;
	resumeApplication: ResumeApplicationResponse[];
}

export class ResumeApplicationResponse {
	application: CompanyApplicationResponse;
	eventGPS: EventGPSResponse;
	photoReferences: string[];
	totalEvents: number;
}

export class PaginationCompanyResponse {
	total: number;
	companies: CompanyResponse[];
}

export class CompanyClosure {
	closedDate: number;
	closedMonth: number;
	closedYear: number;
	companyId: number;
	creationDate: number;
	id: number;
	moduleId: any;
	subModuleId: any;
	userId: number;
}